import React from "react";
import { Container, Typography, Button, Paper, Box, Grid } from "@mui/material";
import PsychologyIcon from "@mui/icons-material/Psychology";
import HistoryIcon from "@mui/icons-material/History";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FlagIcon from "@mui/icons-material/Flag";

const CounsellingContent = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4, fontFamily: "Poppins, sans-serif" }}>
      {/* Header Section */}
      <Typography
        variant="h3"
        component="h1"
        align="center"
        sx={{
          fontWeight: 550,
          mb: 4,
          color: "#2E3B55",
          fontFamily: "poppins",
        }}
      >
        Therapies
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 4, alignContent: 'center' }}>
  {/* First Row */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
    
    {/* Psycho-spiritual Hypnotherapy Section */}
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px',height:'150px', backgroundColor: '#FFFFFFFF', p: 4, mb: 4,border:"1px solid",borderColor:"grey.300", borderRadius:"10px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
  
        <Typography variant="h5" textAlign={"start"} component="h2" sx={{ color: '#2E3B55', fontWeight: '600',fontFamily:"poppins" }}>
          Psycho-spiritual Hypnotherapy
        </Typography>
      </Box>
      <Typography variant="body1" textAlign={"start"} sx={{ color: '#2E3B55', mb: 1,fontFamily:"poppins" }}>
        The process of tapping the subconscious mind:
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
    
        <Typography variant="body1"  textAlign='start' sx={{ color: '#2E3B55',fontFamily:"poppins" }}>Know the cause of our problems.</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
      
        <Typography variant="body1" textAlign='start' sx={{ color: '#2E3B55',fontFamily:"poppins" }}>Cleanse blockages of psychosomatic problems.</Typography>
      </Box>
    </Box>

    {/* Past Life Regression Therapy Section */}
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px',height:'150px', backgroundColor: '#FFFFFFFF', p: 4, mb: 4,border:"1px solid",borderColor:"grey.300", borderRadius:"10px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
    
        <Typography variant="h5" component="h2" textAlign={'start'} sx={{ color: '#2E3B55', fontWeight: '600' ,fontFamily:"poppins"}}>
          Past Life Regression Therapy
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ color: '#2E3B55', mb: 1,fontFamily:"poppins" }} textAlign={'start'}>
        The process of accessing past lives through our subconscious:
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
       
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins" }} textAlign={'start'}>Know the unknown causes of present problems.</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
       
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins" }} textAlign={'start'}>Unburden from psychosomatic issues.</Typography>
      </Box>
    </Box>
  </Box>

  {/* Second Row */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
    
    {/* Progression Therapy Section */}
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px',height:'150px', backgroundColor: '#FFFFFFFF', p: 4, mb: 4,border:"1px solid",borderColor:"grey.300", borderRadius:"10px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        
        <Typography variant="h5" component="h2" sx={{ color: '#2E3B55', fontWeight: '600',fontFamily:"poppins" }} textAlign={'start'}>
          Progression Therapy
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ color: '#2E3B55', mb: 1 ,fontFamily:"poppins"}} textAlign={'start'}>
        The process of knowing if our decisions are relevant and correct for our upcoming future events:
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
      
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins" }} textAlign={'start'}>Remove confusion about decisions.</Typography>
      </Box>
    </Box>

    {/* Goal Setting Section */}
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px',height:'150px', backgroundColor: '#FFFFFFFF', p: 4, mb: 4,border:"1px solid",borderColor:"grey.300", borderRadius:"10px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
    
        <Typography variant="h5" component="h2" sx={{ color: '#2E3B55', fontWeight: '600' ,fontFamily:"poppins"}} textAlign={'start'}>
          Goal Setting
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ color: '#2E3B55', mb: 1 ,fontFamily:"poppins"}} textAlign={'start'}>
        The process of making ourselves ready to face obstacles:
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
       
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins" }} textAlign={'start'}>Overcome obstacles to reach our goals.</Typography>
      </Box>
    </Box>
  </Box>
</Box>


      {/* Call to Action Section */}
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Button
          variant="contained"
          size="large"
          sx={{
            textTransform:"none",
            backgroundColor: "#2E3B55",
            "&:hover": { backgroundColor: "#1A2637" },
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Register Now
        </Button>
      </Box>
    </Container>
  );
};

export default CounsellingContent;
